// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./js/" + ({"4438":"vendor-corejs","6699":"fonts","7332":"iroColorPicker","8107":"mobileClass","8911":"desktopClass","9925":"vendor-customization"}[chunkId] || chunkId) + ".7415992656.bundle.js";
};